import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { apiClient } from '../../../api/axios';
import { showSnackbar } from '../../../api/snackbarSlice';

export const mutateWebhook = async ({ payload, isEdit }) => {
  if (isEdit) {
    const { data } = await apiClient.put(`/webhook-configs/${payload.id}`, payload);
    return data;
  }

  const { data } = await apiClient.post('/webhook-configs', payload);
  return data;
};

export const useMutateWebhookHandler = ({ onSuccess } = {}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: mutateWebhook,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['webhooks'] });
      queryClient.invalidateQueries({ queryKey: ['webhookStats'] });
      dispatch(
        showSnackbar({
          message: 'Webhook saved successfully',
          severity: 'success',
        }),
      );
      onSuccess && onSuccess(variables, data);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        dispatch(
          showSnackbar({
            message: error.response?.data?.message || 'Request failed',
            severity: 'error',
          }),
        );
      }
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
  };
};
